import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_UI_SETTINGS_FAIL = "ORGANIZATION:UPSERT_UI_SETTINGS_FAIL";

export interface UpsertUISettingsFailAction extends Action {
  type: typeof UPSERT_UI_SETTINGS_FAIL;
  organization: OrganizationKeyName;
  errors?: AdminErrorListResponseData;
}

export const upsertUISettingsFail = (
  organization: OrganizationKeyName,
  errors?: AdminErrorListResponseData
): UpsertUISettingsFailAction => ({
  type: UPSERT_UI_SETTINGS_FAIL,
  organization,
  errors,
});
